export const simpleTemplate = `## Hola!👋 Mucho Gusto.😊

Hi i'm Kelechi, a Project Manager with Finance background & love for anything Data or Tech. Open source documentation & translation contributor, working to use data for good, big team player. Python is my first language, loving Markdown too. Igbo native, cartoon freak, chocolate, good food and karaoke.


## More About Me

- 💜 Kind people are my kinda people

- 💯 Radical for Jesus

- ⭐ Uniquely naive tho independent

- 🍎 Beginner mindset (**open to learning**)

- ✨ Child at heart (**i see the world as magical**)


>*I love to race in where angels fear to tread. Committed to face fears & overcome them. In order to escape any feeling of being stuck, i often travel.*


## Find me around the WWW🌎:


- Contributing on: <a href="https://github.com/PluckyPrecious"><img src="https://img.shields.io/github/followers/PluckyPrecious.svg?label=GitHub&style=social" alt="GitHub"></a>


- Trying to be up to good on: <a href="https://twitter.com/PluckyPrecious"><img src="https://img.shields.io/twitter/follow/PluckyPrecious?label=Twitter&style=social" alt="Twitter"></a> 


- Lazy curating pluckyspiration on: [YouTube](https://www.youtube.com/channel/UC2-U73E-uyf_lNCDO0yENlQ?view_as=subscriber) or [WordPress](https://pluckys.home.blog/2019/11/01/the-journey-begins/)


---
⭐️ From [PluckyPrecious](https://github.com/PluckyPrecious)`;

export const dynamicTemplate = ` 
## 👋 Hello World ! 


❤️ Programming | 🖤 K-pop | 💙 Anime


  
I am a Final Year Computer Engineering Student at College of Engineering Chengannur. I love Machine Learning and trying to find more about Full Stack Web Development and Cyber Security. 

- 🔭 I’m currently working on Sign Language Translator to Malayalam Application using Flutter and Python.
- 🌱 I’m currently learning Data Science | Full Stack Web development | App Development | NLP | Cyber Security
- 👯 I’m looking to collaborate on Machine Learning and Web Development Projects <img src="https://media.giphy.com/media/WUlplcMpOCEmTGBtBW/giphy.gif" width="30">
- 💬 Ask me about anything. I will try to help you as much as I can.
- ⚡ Quote: There is always time. You just have to find it.


----

#### <img src="https://media.giphy.com/media/VgCDAzcKvsR6OM0uWg/giphy.gif" width="50"> How about some stats ?
  
 
![Prify Philip's GitHub Stats](https://github-readme-stats.vercel.app/api?username=Amchuz&hide=["stars"]&show_icons=true)

-------

📊 **Weekly development breakdown**

<!--START_SECTION:waka-->

\`\`\`text
Python      4 hrs 32 mins       █████████░░░░░░░░░░░░░░░░   35.69 
HTML/CSS    2 hrs 50 mins       █████░░░░░░░░░░░░░░░░░░░░   22.32 
Javascript  1 hr 10 mins        ██░░░░░░░░░░░░░░░░░░░░░░░   9.17 
Dart        1 hr 5 mins         ██░░░░░░░░░░░░░░░░░░░░░░░   8.61 
\`\`\`

⭐️ From [@Amchuz](https://github.com/Amchuz)
`;

export const codeStyleTemplate = `<h2> Hi, I'm Thai Braga! <img src="https://media.giphy.com/media/mGcNjsfWAjY5AEZNw6/giphy.gif" width="50"></h2>
<img align='right' src="https://media.giphy.com/media/ieyl9zmCjO4b4t6qoY/giphy.gif" width="230">
<p><em>Software Enginner at <a href="http://www.unb.br">University of Brasilia</a><img src="https://media.giphy.com/media/fYSnHlufseco8Fh93Z/giphy.gif" width="30"></br>Developer Consultant at <a href="https://www.thoughtworks.com">ThoughtWorks</a><img src="https://media.giphy.com/media/WUlplcMpOCEmTGBtBW/giphy.gif" width="30"> 
</em></p>

---


[![Twitter: ThaiiBraga](https://img.shields.io/twitter/follow/ThaiiBraga?style=social)](https://twitter.com/ThaiiBraga)
[![Linkedin: thaianebraga](https://img.shields.io/badge/-thaianebraga-blue?style=flat-square&logo=Linkedin&logoColor=white&link=https://www.linkedin.com/in/thaianebraga/)](https://www.linkedin.com/in/thaianebraga/)
[![GitHub Thaiane](https://img.shields.io/github/followers/thaiane?label=follow&style=social)](https://github.com/Thaiane)


### <img src="https://media.giphy.com/media/VgCDAzcKvsR6OM0uWg/giphy.gif" width="50"> A little more about me...  

\`\`\`javascript
const thai = {
  pronouns: "she" | "her",
  code: [Javascript, Typescript, HTML, CSS, Ruby, Python, Java],
  tools: [React, Redux, Node, Storybook, Styled-Components, Jest, Docker],
  architecture: ["microservices", "event-driven", "design system pattern"],
  techCommunities: {
                        coorganizer: "AfroPython",
                        speaker: "Latinity",
                        mentor: "RailsGirls POA"
                      },
 challenge: "I am doing the #100DaysOfCode challenge focused on react and typescript"
}
\`\`\`

<img src="https://media.giphy.com/media/LnQjpWaON8nhr21vNW/giphy.gif" width="60"> <em><b>I love connecting with different people</b> so if you want to say <b>hi, I'll be happy to meet you more!</b> :)</em>

---
---


⭐️ From [@Thaiane](https://github.com/Thaiane)`;
